import { localize, extend } from 'vee-validate'
import { required, max, max_value, min_value } from "vee-validate/dist/rules"
import moment from 'moment-timezone'
import ru from 'vee-validate/dist/locale/ru.json'

extend('required', required)
extend('max', max)
extend('max_value', max_value)
extend('min_value', min_value)

extend('time', (value, args) => {
  const customMsg = args[0]
  if (moment(value, 'HH:mm').isValid()) {
    return true
  }
  if (customMsg) {
    return customMsg
  }
  return 'В поле {_field_} не валидное время'
})

extend('min_time_past', (value, args) => {
  const minTime = args && args[0] ? +args[0] : null
  if (minTime) {
    const minDate = moment().subtract(minTime, 'minutes')
    if (moment(value) < minDate) {
      return `В поле {_field_} должна быть дата не менее ${minTime} мин. в прошлом от текущего момента`;
    }
  }
  return true
})

extend('max_time', (value, args) => {
  
  /**
   * здесь будет объект moment, использовать только для смен
   */
  const maxTime = args[0]
  if (maxTime) {
    const valueMoment = moment(value)
    const maxTimeMoment = moment(maxTime)
    if (valueMoment > maxTimeMoment) {
      return `Смена не может быть больше 24 ч`
    }
    return true
  }
  
})

extend('not_zero', (value) => {
  if (parseInt(value) === 0) {
    return 'Поле {_field_} не может быть равно 0'
  }
  return true
})

localize('ru', ru)